module.exports = __webpack_public_path__ + "img/92192.ea02cf94.svg";